module.exports = __webpack_public_path__ + "media/images/tailwind/youtube-1c0a77ff115fe7af705a8e5af9646c1e.png";